import {useEffect, useState} from 'react';
import {ScrollView, View} from 'react-native';
import {Button} from 'react-native-paper';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {RootPrivacyIntroScreenProps} from '../../Typings/NavigationTypes';
import {getCopy} from '../../Utils/I18n';
import {TelemetryConfig, loadTelemetryConfig} from '../../Utils/Telemetry';
import getStyles from './ADAPT-MH.styles';

type Props = RootPrivacyIntroScreenProps;

const PrivacyIntro: React.FC<Props> = ({navigation, route}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const {clinical, language} = route.params;
  const copy = getCopy(language);
  const screenCopy = clinical ? copy.clinicalPrivacy : copy.privacy;
  const [sharingConfig, setSharingConfig] = useState<TelemetryConfig | null>(null);

  useEffect(() => {
    loadTelemetryConfig().then(setSharingConfig);
  }, []);

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            {screenCopy.title}
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            {screenCopy.subtitle}
          </Text>
        </View>

        <View style={styles.card}>
          <Text weight="bold" fontSize={18} style={styles.strongBody}>
            {screenCopy.privateTitle}
          </Text>
          {screenCopy.bullets.map((bullet) => (
            <Text key={bullet} style={styles.listItem}>
              {`- ${bullet}`}
            </Text>
          ))}
        </View>

        {!clinical ? (
          <View style={styles.softCard}>
            <Text style={styles.body}>{copy.privacy.note}</Text>
          </View>
        ) : null}

        {clinical && sharingConfig?.enabled ? (
          <View style={styles.softCard}>
            <Text style={styles.body}>
              {copy.clinicalPrivacy.sharingNotice.replace('{site}', sharingConfig.siteCode)}
            </Text>
          </View>
        ) : null}

        <Button
          mode="contained"
          onPress={() => {
            if (clinical) {
              navigation.navigate('Questions', {
                mode: 'recommended',
                language,
                assessmentMode: 'guided',
                startedByProvider: true,
                sharingConsent: 'share-summary',
                reset: true,
              });
              return;
            }

            navigation.navigate('Orientation', {language});
          }}
          style={styles.button}
          buttonColor={theme.colors.primary}
          textColor={theme.colors.textContrast}
        >
          {screenCopy.continue}
        </Button>
      </ScrollView>
    </PageContainer>
  );
};

export default PrivacyIntro;
